export const load = () => ({
	title: 'Home Energy Scores And How To Improve Yours',
	showTitle: true,
});
